import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./context/Store/store";
import React, { useState } from "react";
import { ScrollToTop } from "./index";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import MainApp from "./MainApp";
import { useToast } from "@chakra-ui/react";

// export const SHARED_DOMAINS = ["staging", "demo"];

function AuthProviderWrapper() {
  // const toast = useToast();
  // const [organizationId, setOrganizationId] = useState(null);

  const auth0ProviderConfig = {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    audience: process.env.REACT_APP_AUTH_AUDIENCE,
    redirectUri: window.location.origin,
    useRefreshTokens: true,
    cacheLocation: "localstorage",
  };

  // TODO: Commented this out since org slection is now handled by Auth0, to remove once it's tested and safe

  // const subdomain = process.env.REACT_APP_SUBDOMAIN || window.location.hostname.split(".")[0];
  // const isSharedDomain = SHARED_DOMAINS.includes(subdomain);

  // useEffect(() => {
  //   // if subdomains is not shared domain, use subdomain to get the org id directly
  //   if (!isSharedDomain) {
  //     console.log("Dedicated domain detected, using subdomain", subdomain);
  //     OrganizationAdministration.getOrganizationId(subdomain)
  //       .then((orgId) => {
  //         setOrganizationId(orgId);
  //       })
  //       .catch(function (error) {
  //         showErrorToast(toast, error.message);
  //       });
  //   } else {
  //     // if local storage have org id, set it
  //     const localStorageOrgDomain = localStorage.getItem("organizationDomain");
  //     if (localStorageOrgDomain) {
  //       setOrganizationId(localStorageOrgDomain);
  //       console.log("Using local storage org domain", subdomain);
  //     }
  //   }
  // }, [isSharedDomain, subdomain, toast]);
  //
  // if (!isSharedDomain && !organizationId) {
  //   return <LocalSpinner />;
  // }

  return (
    <Auth0Provider {...auth0ProviderConfig}>
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop />

          <MainApp />
        </BrowserRouter>
      </Provider>
    </Auth0Provider>
  );
}

export default AuthProviderWrapper;
